import * as React from "react";

import { useRateCards } from "@v2/features/agent-billing/hooks/useRateCards";

import { ReadOnlyJsonEditor } from "./shared";

export const RawRateCardsJson: React.FC = () => {
  const { rateCards } = useRateCards();

  return (
    <div className="flex flex-col gap-1.5">
      <span className="text-muted text-xs">
        Response from subscription.findRateCards tRPC query (rate cards for all
        plans, including prices, features, and add-on products)
      </span>
      {rateCards ? (
        <ReadOnlyJsonEditor value={rateCards} />
      ) : (
        <div className="text-muted text-xs">No rate cards</div>
      )}
    </div>
  );
};
